<template>
  <div :class="input.customized.connected ? 'connected' : 'disconnected'">
    <img
      class="tool"
      :src="require(`@/${input.root}/${input.toolbar.path}`)"
    />
    <v-icon
      style="vertical-align: middle"
      v-if="input.customized.connected"
      large
      >mdi-access-point
    </v-icon>
    <v-icon
      style="vertical-align: middle"
      v-else
      large
      >mdi-access-point-off
    </v-icon>
  </div>
</template>

<script>
import { Buffer } from "buffer";

import { mapActions, mapState } from "vuex";

export default {
  name: "KoioteOmronConnection",
  props: {
    input: Object,
  },

  computed: {
    ...mapState("nodered", ["client", "showing_history_address"]),
  },

  methods: {
    ...mapActions("nodered", ["doSubscribe", "doUnsubscribe", "doPublish", "addHistoryValue"]),
  },

  created() {
    this.doSubscribe(this.input.customized.topic_read);

    this.client.on("message", (topic, message) => {
      if (topic === this.input.customized.topic_read) {
        const decodedMessage = JSON.parse(message);
        const {
          MemoryArea: memoryArea,
          Address: firstAddress,
          isBitAddress,
          Bit,
        } = decodedMessage.fins.request.address;
        let currentAddress = firstAddress;
        let bit = Bit;

        for (let i = 0; i < decodedMessage.read.data.length; i++) {
          const transformedAddress = `${memoryArea}${currentAddress}${isBitAddress ? `.${("0" + bit).slice(-2)}` : ""}`;
          const variableToChange = this.input.customized.vartable.find(
            (v) => v.formatted_address == transformedAddress
          );
          if (variableToChange) {
            variableToChange.value = (() => {
              switch (variableToChange.type) {
                case "BIT": {
                  currentAddress = bit === 15 ? currentAddress + 1 : currentAddress;
                  bit = bit === 15 ? 0 : bit + 1;
                  return Boolean(decodedMessage.read.data[i]);
                }
                case "ENTERO": {
                  currentAddress = currentAddress + 1;
                  const A = decodedMessage.read.data[0 + i];
                  const B = decodedMessage.read.data[1 + i];
                  i = i + 1;
                  return 256 * A + B;
                }
                case "REAL": {
                  currentAddress = currentAddress + 2;
                  const A = decodedMessage.read.data[0 + i];
                  const B = decodedMessage.read.data[1 + i];
                  const C = decodedMessage.read.data[2 + i];
                  const D = decodedMessage.read.data[3 + i];
                  const newbuf = Buffer.from([C, D, A, B]);
                  i = i + 3;
                  return newbuf.readFloatBE();
                }
                default:
                  return "";
              }
            })();
            if (variableToChange.formatted_address == this.showing_history_address)
              this.addHistoryValue(variableToChange);
          }
        }
      }
    });
  },

  beforeDestroy() {
    this.doUnsubscribe(this.input.customized.topic_read);
  },
};
</script>

<style scoped>
.disconnected {
  height: 100%;
  text-align: center;
  border: dotted 2px black;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.connected {
  height: 100%;
  text-align: center;
  border: dotted 2px black;
  background-color: #4caf5050;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.tool {
  height: 37px;
  width: 66px;
  resize: both;
}
</style>
